<template>
  <v-container class="pa-0" style="background-color: transparent;height: 100%;display: flex; flex-direction: column;">
    <v-dialog ref="dialog" v-model="foreignUser" persistent width="320px" overlay-color="black" overlay-opacity="0.95">
      <v-card>
        <v-card-text class="text-center" style="color: black; vertical-align: middle">
          <p style="vertical-align: middle;">
            You are not a member of this chat!
          </p>
        </v-card-text>
      </v-card>
    </v-dialog>
    <div style="background-color: whitesmoke; height: 8vh; display: flex;align-items: center;">
      <v-icon v-if="$user" @click="goBack">
        mdi-chevron-left
      </v-icon>
      <ItemListChat v-if="chatInformation" :hide-last-message="true" :chat="chatInformation" />
      <v-menu>
        <template v-slot:activator="{ on }">
          <v-icon v-on="on">
            mdi-dots-vertical
          </v-icon>
        </template>
        <v-list>
          <span v-for="(item, i) in items" v-if="chatInformation" :key="i">
            <v-list-item v-if="!item.hide" @click="makeAction(i)">
              <v-list-item-title>
                <v-icon>{{ item.icon }}</v-icon>
                {{ item.text }}
              </v-list-item-title>
            </v-list-item>
          </span>
        </v-list>
      </v-menu>
    </div>
    <div v-if="chatInformation" style="background: whitesmoke;text-align: center;display: flex;justify-content: space-evenly; align-items: center; padding-bottom: 10px">
      <RemindInvitationComponent v-if="iAmCreator && haveToRemindJoinChat" :invite="invite" :invite-byppay="inviteByppay" :chat="chatInformation" @remindInvite="haveRemindInvite" />
      <AddInvoiceToChat v-if="iAmCreator && !haveToRemindJoinChat && haveToAddInvoice" :chat-id="idChat" :other-members="otherMembers" :invoice-created="createdInvoice" :chat="chatInformation" @invoiceAdded="refresh(false)" />
      <PaymentInformationButton v-if="iAmReceiver" ref="paymentInformationModal" :chat="chatInformation" :show-button="haveToCompletePaymentMethods" @sendSystemHour="sendSystemHour" @refresh="refresh(false)" />
      <PaymentInformationRemindButton v-if="haveToCompletePaymentMethods && iAmPayer && !haveToRemindJoinChat" :remind-payment="remindPaymentMethods" :chat="chatInformation" @reminded="haveRemindedPaymentInformation" />
      <PaymentChatComponent v-if="iAmPayer && haveToPay" :wanto-pay="pay" :chat="chatInformation" @payed="refresh(false)" @sendSystemHour="sendSystemHour" />
      <AcceptPaymentOutsitePlatform v-if="iAmReceiver && haveToAcceptPaymentOutsidePlatform" :chat="chatInformation" @accepted="refresh(false)" @sendSystemHour="sendSystemHour" />
      <BypaymentChatComponent v-if="iAmPayer && haveToPayInvoice" :created-invoice="createdInvoice" :create-byppass="createByppass" :chat="chatInformation" @byppayAdded="createdByppass" @refresh="refresh(false)" />
      <AcceptBypaymentChatComponent v-if="haveFactoringCreated && iAmReceiver" :chat="chatInformation" @accepted="acceptedByppass" @decline="declineByppass" />
      <ItemMessageFormInvite v-if="iAmInvoicePayer && haveToInvite" :chat="chatInformation" :user-to-invite="inviteUser" @invited="haveInvited" @refresh="refresh(false)" />
      <PaymentRemindButton v-if="haveToRemindPayment" :chat="chatInformation" :remind-pay="remindToPay" :cif-payer="getCifPayer" @reminded="remindedToPay" />
      <GenerateContractByppayPdf v-if="chatInformation.factoring !== null" ref="generateContractByppayPdf" :chat="chatInformation" />
    </div>

    <div id="chatBox" style="overflow-y: auto; overflow-x: hidden;flex: 1;">
      <div v-if="!load" style="text-align: center;">
        <v-progress-circular
          style="margin-top: 10px"
          :size="70"
          :width="7"
          indeterminate
          color="primary"
        />
      </div>
      <div v-for="item in messages" v-if="!showForms && load" :key="item.id">
        <v-row>
          <ItemMessage :id="item.id" :left="item.sender && item.sender._id !== $user._id" :message="item" />
        </v-row>
      </div>
    </div>
    <div style="flex: 0;display: flex; background-color: whitesmoke;">
      <div style="flex: 0;display: flex;">
        <v-icon x-large @click="modalFile = !modalFile">
          mdi-plus-circle-outline
        </v-icon>
        <v-dialog ref="dialog" v-model="modalFile" width="320px">
          <v-form style="background-color: white;">
            <v-file-input v-model="file" style="margin-left: 2vh; margin-right: 2vh;" small-chips :label="$t('chat.file-input')" />
            <v-btn style="margin: auto" text color="#00E5FF" @click="sendFile(); modalFile = !modalFile">
              {{ $t('chat.add-file') }}
            </v-btn>
          </v-form>
        </v-dialog>
      </div>
      <v-text-field v-model="message" type="text" :placeholder="$t('Chat.Message')" style="background-color: whitesmoke; margin-left: 13px" @keyup.enter="sendMessage" />
      <v-icon x-large @click="sendMessage">
        mdi-send-circle-outline
      </v-icon>
      <v-icon x-large @click="help">
        mdi-help-circle-outline
      </v-icon>
    </div>
  </v-container>
</template>

<script>
import ItemListChat from "../components/ItemListChat";
import ItemMessage from "../components/ItemMessage";
import PaymentInformationButton from "../components/PaymentInformationButton";
import PaymentInformationRemindButton from "../components/PaymentInformationRemindButton";
import PaymentRemindButton from "../components/PaymentRemindButton";
import ApiRepository from "../repositories/ApiRepository";
import Vue from "vue";
import PaymentChatComponent from "../components/PaymentChatComponent";
import RemindInvitationComponent from "../components/RemindInvitationComponent";
import AddInvoiceToChat from "../components/AddInvoiceToChat";
import BypaymentChatComponent from "../components/BypaymentChatComponent";
import AcceptBypaymentChatComponent from "../components/AcceptBypaymentChatComponent";
import AcceptPaymentOutsitePlatform from "../components/AcceptPaymentOutsitePlatform";
import ItemMessageFormInvite from "../components/ItemMessageFormInvite";
import GenerateContractByppayPdf from "../components/GenerateContractByppayPdf";
import Constants from "../../constants";
import { atcb_action } from "add-to-calendar-button";
import "add-to-calendar-button/assets/css/atcb.css";

import useSound from 'vue-use-sound';
import buttonSfx from '../../public/ding.mp3';
import html2canvas from "html2canvas";

export default {
    name: "Chat",
    components: { ItemMessage, ItemListChat, ItemMessageFormInvite,
        PaymentInformationButton, PaymentChatComponent, BypaymentChatComponent,
        AcceptBypaymentChatComponent, PaymentInformationRemindButton,
        RemindInvitationComponent, PaymentRemindButton, AddInvoiceToChat,
        AcceptPaymentOutsitePlatform, GenerateContractByppayPdf},
    setup () {
        const [play] = useSound(buttonSfx);
        return {
            play,
        };
    },
    data () {
        return {
            chatInformation: null,
            invoice: {},
            createByppass: false,
            loginToken: "",
            idChat: "",
            idInvoice: "",
            createdInvoice: undefined,
            message: "",
            showForms: false,
            invite: false,
            addressTemp: "di2nidunudd12oi9nddwcocd", //adreça temporal que s'haurà de canviar segurament per idUsuari
            messages: [],
            byppay: false,
            payer: false,
            receiver: false,
            payerName: "",
            receiverName: "",
            outstandingAmmount: 0,
            Constants: Constants,
            byppayAmmount: 0,
            percentage: 0,
            modalFile: false,
            optionFiles: ["Fitxer", "Imatge"],
            file: null,
            fab: false,
            items: [],
            secondUserId: "",
            idFactoring: "",
            factoring: "",
            foreignUser: false,
            registered: false,
            archived: false,
            load: false,
            eventData: {},
            unread: 0,
            readMessages: false,
            pay: false,
            remindPaymentMethods: false,
            remindToPay: false,
            inviteByppay: false,
        };
    },
    computed: {
        iAmCreator () {
            return this.chatInformation && this.$user._id === this.chatInformation.creator;
        },
        haveToAddInvoice () {
            return this.chatInformation && !this.chatInformation.invoice;
        },
        haveToCompletePaymentMethods () {
            return !this.haveToAddInvoice && this.chatInformation && this.chatInformation.paymentInformation === null;
        },
        iAmReceiver () {
            return !this.haveToAddInvoice && this.chatInformation && this.$user._id === this.chatInformation.invoice.receiver._id;
        },
        iAmPayer () {
            return !this.haveToAddInvoice && this.chatInformation &&
                (this.$user._id === this.chatInformation.invoice.payer._id && this.doesntHaveFactoringInProgress) ||
                    (this.haveFactoringAccepted && this.$user._id === this.chatInformation.factoring.payer._id);
        },
        getCifPayer () {
            if (!this.haveToAddInvoice && this.chatInformation) {
                if (this.doesntHaveFactoringInProgress) {
                    return this.chatInformation.invoice.payer.cif;
                } else if (this.haveFactoringAccepted) {
                    return this.chatInformation.factoring.payer.cif;
                }
            }
            return null;
        },
        iAmInvoicePayer () {
            return !this.haveToAddInvoice && this.chatInformation && this.$user._id === this.chatInformation.invoice.payer._id;
        },
        haveToRemindJoinChat () {
            return this.chatInformation && this.chatInformation.invited.length > 0;
        },
        haveToPayInvoice () {
            return !this.haveToAddInvoice && !this.haveToCompletePaymentMethods &&
                this.chatInformation.invoice.outstandingAmmount > 0 && this.chatInformation.invoice.status === Constants.INVOICE.STATUS_CREATED && this.doesntHaveFactoringInProgress;
        },
        haveToPayFactoring () {
            return !this.haveToAddInvoice && !this.haveToCompletePaymentMethods &&
                this.haveFactoringAccepted && this.chatInformation.factoring.payerPaymentToReceiver === Constants.FACTORING.STATUS_UNPAYED;
        },
        haveToPay () {
            return this.haveToPayInvoice || this.haveToPayFactoring;
        },
        haveToAcceptPaymentOutsidePlatform () {
            return !this.haveToAddInvoice && !this.haveToCompletePaymentMethods &&
                ((this.chatInformation.invoice.status === Constants.INVOICE.OUTSIDE_PAYMENT && this.doesntHaveFactoringInProgress) ||
                    (this.haveFactoringAccepted && this.chatInformation.factoring.payerPaymentToReceiver === Constants.FACTORING.STATUS_PAYED));
        },
        haveFactoringCreated () {
            return this.chatInformation && this.chatInformation.factoring !== null && this.chatInformation.factoring.status === Constants.FACTORING.STATUS_CREATED;
        },
        haveFactoringAccepted () {
            return this.chatInformation && this.chatInformation.factoring !== null && this.chatInformation.factoring.status === Constants.FACTORING.STATUS_PAYED;
        },
        doesntHaveFactoringInProgress () {
            return !this.haveFactoringCreated && !this.haveFactoringAccepted;
        },
        invoiceHaveFactoringCreated () {
            return this.chatInformation.factoring !== null;
        },
        haveToRemindPayment () {
            return !this.haveToCompletePaymentMethods && !this.haveToInvite && !this.haveToRemindJoinChat && this.iAmReceiver && !this.haveToAcceptPaymentOutsidePlatform &&
                ((this.chatInformation.invoice.status === Constants.INVOICE.STATUS_CREATED && !this.invoicePayed && !this.haveFactoringCreated) ||
                (this.chatInformation.factoring && this.chatInformation.factoring.payerPaymentToReceiver === Constants.FACTORING.STATUS_UNPAYED));
        },
        aIsNotMemberOrInvited () {
            return this.chatInformation && this.haveFactoringAccepted
                && this.chatInformation.members.find(e => e._id === this.chatInformation.factoring.payer._id) === undefined
                && this.chatInformation.invited.find(e => e._id === this.chatInformation.factoring.payer._id) === undefined;
        },
        haveToInvite () {
            return this.chatInformation  &&
              (this.chatInformation.members.length < 2 ||
                  (this.chatInformation.factoring && !this.haveFactoringCreated && this.chatInformation.members.length < 3) ) && !this.haveToRemindJoinChat;
        },

        inviteUser () {
            return this.chatInformation.factoring.payer;
        },

        // ------------------------------------------------------ //
        otherMembers () {
            return this.chatInformation.members.filter(e => e._id !== this.$user._id);
        },
        // ------------------------------------------------------ //
        noMiddle () {
            return this.chatInformation && (this.chatInformation.middle === undefined || this.chatInformation.middle === null);
        },
        noPayer () {
            return this.chatInformation && (this.chatInformation.payer === undefined || this.chatInformation.payer === null);
        },
        noReceiver () {
            return this.chatInformation && (this.chatInformation.receiver === undefined || this.chatInformation.receiver === null);
        },
        haveToPayByppay () {
            return !this.haveToCompletePaymentMethods() && this.iAmPayer() && (this.invoice.relatedFactorings.find(element => element.status === Constants.FACTORING.STATUS_PAYED && element.payerPaymentToReceiver === Constants.FACTORING.STATUS_UNPAYED) !== undefined);
        },
        haveToRemindPay () {
            return !this.haveToCompletePaymentMethods && !this.invoiceHaveFactoringCreated && this.iAmReceiver && !this.haveToAcceptPaymentOutsidePlatform;
        },
        haveToPayBayppay () {
            return  this.haveToPay && !this.invoiceHaveFactoringsAccepted;
        },
        invoiceHaveFactoringsAccepted () {
            return this.invoice && this.invoice.relatedFactorings && (this.invoice.relatedFactorings.find(element => element.status === Constants.FACTORING.STATUS_PAYED && element.payerPaymentToReceiver === Constants.FACTORING.STATUS_UNPAYED) !== undefined);
        },
        invoiceHaveOpenedFactoring () {
            return this.chatInformation.factoring && !this.chatInformation.factoring.status === 3;
        },
        invoicePayed () {
            return this.chatInformation.invoice && this.chatInformation.invoice.outstandingAmmount <= 0 && !this.invoiceHaveOpenedFactoring;
        },
        getCreatedFactoring () {
            if (this.invoice && this.invoice.relatedFactorings) {
                return this.invoice.relatedFactorings.find(element => element.status === Constants.FACTORING.STATUS_CREATED);
            } else {
                return null;
            }
        },
        getRelatedFactoring () {
            if (this.invoice && this.invoice.relatedFactorings) {
                return this.invoice.relatedFactorings.find(element => element.status === Constants.FACTORING.STATUS_PAYED);
            } else {
                return null;
            }
        },
        getUnpayedfactoring () {
            if (this.invoice && this.invoice.relatedFactorings) {
                return this.invoice.relatedFactorings.find(element => element.status === Constants.FACTORING.STATUS_PAYED && element.payerPaymentToReceiver === Constants.FACTORING.STATUS_UNPAYED );
            } else {
                return null;
            }
        },
        getPendingOutsidePaymentfactoring () {
            if (this.invoice && this.invoice.relatedFactorings) {
                return this.invoice.relatedFactorings.find(element => element.status === Constants.FACTORING.STATUS_PAYED && element.payerPaymentToReceiver === Constants.FACTORING.STATUS_PAYED );
            } else {
                return null;
            }
        },
        getInviteUserMail () {
            if (this.haveToInvite && !this.invoiceHaveOpenedFactoring) {
                if (this.iAmReceiver && this.invoice.payer) {
                    return this.invoice.payer;
                } else if (this.iAmPayer && this.invoice.receiver) {
                    return this.invoice.receiver;
                }
                return {email: ""};

            } else if (this.haveToInvite && this.invoiceHaveOpenedFactoring && this.getRelatedFactoring.payer) {
                return this.getRelatedFactoring.payer;
            }
            return {email: ""};
        },
    },
    created () {
        this.unread = 0;
        let deleteParams = false;
        this.readMessages = true; //inicialitzem la variable per poder amagar ultim missatge i poder refrescar les notificacions dels missatges
        const url = this.getAllUrlParams(window.location.href);
        if (url.chatid !== undefined) {
            this.idChat = url.chatid;
        }
        if (url.unread !== undefined) {
            this.unread = url.unread;
        }
        window.addEventListener("focus", () => {
            this.fetch();
        });
        ApiRepository.isInvited(this.$user._id, this.idChat).then((res) => {
            if (res.data.isInvited) {
                ApiRepository.addNewMember(this.$user._id, this.idChat).then((res) => {
                    let user = "";
                    if (this.$user.name !== undefined) {
                        user = this.$user.name;
                    } else {
                        user = this.$user.cif;
                    }
                    if (!this.chatInformation.factoring) {
                        ApiRepository.sendMessage("0", this.idChat, JSON.stringify({
                            message: 'chat.enterDownStream',
                            extraMessage: 'chat.enterDownStreamExtra',
                            params: {user: user, payerUser: res.data.creator}
                        }), 'chat.enterDownStream');
                    } else {
                        ApiRepository.sendMessage("0", this.idChat, JSON.stringify({
                            message: 'chat.enterUpStream',
                            extraMessage: 'chat.enterUpStreamExtra',
                            params: {user: user}
                        }), 'chat.enterUpStream');
                    }
                });
            } else {
                ApiRepository.isMember(this.$user._id, this.idChat).then((res) => {
                    if (!res.data.isMember) {
                        this.foreignUser = true;
                    }
                });
            }
        });
        if (url.createdinvoice !== undefined) {
            deleteParams = true;
            this.createdInvoice = url.createdinvoice;
        }
        if (url.createbyppass !== undefined) {
            deleteParams = true;
            this.createByppass = url.createbyppass === 'true';
        }
        if (url.pay !== undefined) {
            this.pay = true;
        }
        if (url.invite !== undefined) {
            this.invite = true;
        }
        if (url.remindpaymentmethods) {
            this.remindPaymentMethods = true;
        }
        if (url.remindtopay) {
            this.remindToPay = true;
        }
        if (url.invitebyppay) {
            this.inviteByppay = true;
        }
        if (this.pay || this.inviteByppay || this.invite || this.remindPaymentMethods || this.remindToPay || url.unread !== undefined)
            this.$router.replace({'query': {chatId: this.idChat}});
        if (deleteParams) {
            this.$router.replace({'query': {chatId: this.idChat, invoiceId: this.idInvoice, loginToken: this.loginToken}});
        }
        this.detectFocusOut();
    },
    mounted () {
        this.eventData = {
            name: "Event",
            startDate: "12-02-2022",
            endDate: "13-02-2022",
            options: [
                "Apple",
                "Google",
                "iCal"
            ],
            trigger: "click",
            listStyle: "list",
            iCalFileName: "download_reminder"
        };
        this.fetch();
    },
    methods: {
        detectFocusOut () {
            let inView = false;
            window.onfocus = window.onblur = window.onpageshow = window.onpagehide = (e) => {
                if ({ focus: 1, pageshow: 1 }[e.type]) {
                    if (inView) return;
                    this.tabFocus = true;
                    inView = true;
                } else if (inView) {
                    this.tabFocus = !this.tabFocus;
                    inView = false;
                    this.fetch();
                }
            };
        },
        fetch () {
            this.$socket.connect();
            if (this.readMessages) {
                if (this.unread > 0)
                    ApiRepository.readMessages(this.unread, this.idChat);
                else {
                    ApiRepository.readMessages(1, this.idChat);
                }
                this.readMessages = false; //Vol dir que estem dins del xat, ja que estem amagant l'ultim missatge en el ItemListChat
            }
            if (this.$user.password) this.registered = true;
            ApiRepository.getMessagesFromChat(this.idChat).then((chatMessages) => {
                if (chatMessages.data && chatMessages.data.messages && this.messages.length < chatMessages.data.messages.length) {
                    this.messages = [];
                    this.messages = chatMessages.data.messages;
                    this.scrollToBottom();
                    this.load = true;
                }
            }).catch((err) => {
                console.log(err);
            }).finally(() => {
                this.load = true;
            });
            ApiRepository.getChat(this.idChat).then((chatInformation) => {
                if (JSON.stringify(this.chatInformation) !== JSON.stringify(chatInformation.data.chat)) {
                    this.chatInformation = null;
                    this.chatInformation = chatInformation.data.chat;
                    if (this.chatInformation.archived.length > 0) {
                        const chatArchived = this.chatInformation.archived.filter(user => user === this.$user._id);
                        this.archived = chatArchived.length > 0;
                    } else {
                        this.archived = false;
                    }
                    this.items = [
                        {'text': this.$t('chat.see-invoice'), 'icon': 'mdi-receipt-text-outline', 'hide': false},
                        {'text': this.$t('chat.see-files'), 'icon': 'mdi-paperclip', 'hide': false},
                        {'text': this.$t('chat.edit-payment-info'), 'icon': 'mdi-cash-100', 'hide': !this.iAmReceiver},
                        {'text': this.$t('chat.view-contract'), 'icon': 'mdi-book-edit-outline', 'hide': !this.haveFactoringAccepted},
                        {'text': this.$t('chat.archive-chat'), 'icon': 'mdi-archive-arrow-down-outline', 'hide': this.archived},
                        {'text': this.$t('chat.unarchive-chat'), 'icon': 'mdi-archive-arrow-up-outline', 'hide': !this.archived},
                        {'text': this.$t('chat.add-to-calendar'), 'icon': 'mdi-calendar-outline', 'hide': this.haveToAddInvoice}];
                    this.scrollToBottom();
                }
            }).catch((err) => {
                console.log(err);
            });
        },
        downloadInvoicePayer () {
            const sel = "#capture";
            this.downloading = true;
            html2canvas(document.querySelector(sel), {}).then(canvas => {
                const a = document.createElement("a");
                a.setAttribute('href', canvas.toDataURL('image/png'));
                a.setAttribute('download', 'InvoicePayer.png');
                a.click();
            });
        },
        help () {
            ApiRepository.messageHelp(this.idChat).then((res) => {
            }).catch((e) => {
                this.$root.$emit('show-snackbar', {message: this.$t('chat.errorMessageHelp'), color: "error"});
                console.log(e);
            });
        },
        notify () {
            this.$notification.show('Hello World', {
                body: 'This is an example!'
            }, {});
        },
        scrollToBottom () {
            Vue.nextTick(() => {
                const container = this.$el.querySelector("#chatBox");
                container.scrollTop = container.scrollHeight;
            });
        },
        isIOS () {
            const userAgent = navigator.userAgent || navigator.vendor || window.opera;
            return /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
        },
        async remindedToPay (event) {
            let user = event.phone;
            if (event.remindMethod === 1) {
                user = event.mail;
            }
            await this.sendSystemHour();
            ApiRepository.sendMessage("0", this.idChat, JSON.stringify({message: 'chat.remind-to-pay',  extraMessage: 'chat.remind-to-payExtra', params: {user: this.getMyName(), payer: this.chatInformation.invoice.payer.name}}), 'chat.remind-to-pay').then(() => {
                this.message = "";
                this.fetch();
            });
        },
        async haveRemindedPaymentInformation (event) {
            let user = event.phone;
            if (event.remindMethod === 1) {
                user = event.mail;
            }
            await this.sendSystemHour();
            ApiRepository.sendMessage("0", this.idChat, JSON.stringify({message: 'chat.remind-paymentMethod', extraMessage: 'chat.remind-paymentMethodExtra', params: {user: this.getMyName(), payer: this.chatInformation.invoice.receiver.name}}), 'chat.remind-paymentMethod').then(() => {
                this.message = "";
                this.fetch();
            });
        },
        refresh (clearMessage = true) {
            if (clearMessage) {
                this.message = "";
            }
            this.fetch();
        },
        async haveInvited (event) {
            let user = event.phone;
            if (event.inviteMethod === 1) {
                user = event.mail;
            }
            await this.sendSystemHour();
            ApiRepository.sendMessage("0", this.idChat, JSON.stringify({message: 'chat.inviteDownStream', extraMessage: 'chat.inviteDownStreamExtra', params: {user: this.getMyName(), userInvited: this.getMyName(false, this.getInviteUserMail)}}),  'chat.inviteDownStream').then(() => {
                this.message = "";
                this.fetch();
            });
        },
        addToCalendar () {
            if (this.chatInformation.invoice.receiver.cif !== this.$user.cif) this.eventData.name = "Byppay with " + this.chatInformation.invoice.receiver.name;
            else this.eventData.name = "Byppay with " + this.chatInformation.invoice.payer.name;
            this.eventData.endDate = this.chatInformation.invoice.dueDate.split("T")[0];
            this.eventData.startDate = this.chatInformation.invoice.date.split("T")[0];

            if (!this.isIOS()) {
                this.eventData.options = ["Google", "iCal"];
            }

            atcb_action(this.eventData);
        },
        async haveRemindInvite () {
            await this.sendSystemHour();
            ApiRepository.sendMessage("0", this.idChat, JSON.stringify({message: 'chat.remindInvite', params: {}})).then(() => {
                this.fetch();
            });
        },
        createdByppass () {
            this.createByppass = false;
            this.createdInvoice = undefined;
        },
        async acceptedByppass () {
            await this.sendSystemHour();
            await ApiRepository.sendMessage("0", this.idChat, JSON.stringify({message: 'chat.acceptedByppay', extraMessage: 'chat.acceptedByppayExtra', params: {user: this.getMyName(), payer: this.chatInformation.invoice.payer.name}}),  'chat.acceptedByppay').then(async () => {
                await ApiRepository.generateByppayAgreement(this.idChat).then(async (res) => {
                    await ApiRepository.sendFile(this.$user._id.toString(), this.idChat, "", res.data.agreementName);
                });
                this.fetch();
            });
        },
        async declineByppass () {
            await this.sendSystemHour();
            ApiRepository.sendMessage("0", this.idChat, JSON.stringify({message: 'chat.rejectedByppay', extraMessage: 'chat.rejectedByppayExtra', params: {user: this.getMyName(), payerUser: this.chatInformation.invoice.payer.name}}), 'chat.rejectedByppay').then(() => {
                this.fetch();
            });
        },
        async sendFile () {
            if (this.file !== undefined && this.file !== null) {
                await this.sendSystemHour();
                const extension = this.file.name.split('.').pop().toLowerCase();
                const newFile = new File([this.file], this.$user._id.toString() + "." + extension, {type: this.file.type});
                await ApiRepository.savePublic(newFile).then(async (res) => {
                    await ApiRepository.sendFile(this.$user._id.toString(), this.idChat, "", res.data.path).then((res) => {
                        console.log(res);
                        this.file = undefined;
                        this.fetch();
                    });
                });
            } else
                this.$root.$emit('show-snackbar', {message: this.$t('chat.insertFile'), color: "error"});
        },
        async sendSystemHour () {
            if (this.messages.length > 0) {
                const messageDay = new Date(this.messages[this.messages.length - 1]);
                const today = new Date();
                if ( today.getTime() - messageDay.getTime() > 0) {
                    ApiRepository.sendMessage("0", this.idChat, JSON.stringify({
                        message: 'chat.newDate',
                        params: {day: today.getDay(), month: today.getMonth() + 1, year: today.getFullYear()}
                    }),  'chat.newDate').then(() => {
                        this.message = "";
                        this.fetch();
                    });
                }
            } else {
                const today = new Date().getDate();
                const thisMonth = new Date().getMonth() + 1;
                const thisYear = new Date().getFullYear();
                await ApiRepository.sendMessage("0", this.idChat, JSON.stringify({
                    message: 'chat.newDate',
                    params: {day: today, month: thisMonth, year: thisYear}
                }),  'chat.newDate').then(() => {
                    this.fetch();
                });
            }
        },
        async sendMessage () {
            if (this.message !== "") {
                await this.sendSystemHour();
                ApiRepository.sendMessage(this.$user._id.toString(), this.idChat, this.message).then((res) => {
                    this.message = "";
                    this.fetch();
                });
            } else {
                this.$root.$emit('show-snackbar', {message: this.$t('chat.insertMessage'), color: "error"});
            }
        },
        seeInvoice () {
            this.$router.push({path: 'AllInvoicesChat', query: { chatId: this.idChat }});
        },
        seeFiles () {
            this.$router.push({path: 'AllFilesChat', query: {chatId: this.idChat}});
        },
        goBack () {
            if (!this.archived)
                this.$router.push({name: 'InvoiceChats', replace: true});
            else
                this.$router.push({name: 'InvoiceChatsArchived', replace: true});
        },
        getAllUrlParams (url) {
            // get query string from url (optional) or window
            let queryString = url ? url.split('?')[1] : window.location.search.slice(1);

            // we'll store the parameters here
            const obj = {};

            // if query string exists
            if (queryString) {

                // stuff after # is not part of query string, so get rid of it
                queryString = queryString.split('#')[0];

                // split our query string into its component parts
                const arr = queryString.split('&');

                for (const element of arr) {
                    // separate the keys and the values
                    const a = element.split('=');

                    // set parameter name and value (use 'true' if empty)
                    let paramName = a[0];
                    let paramValue = typeof (a[1]) === 'undefined' ? true : a[1];

                    // (optional) keep case consistent
                    paramName = paramName.toLowerCase();
                    if (typeof paramValue === 'string') paramValue = paramValue.toLowerCase();

                    // if the paramName ends with square brackets, e.g. colors[] or colors[2]
                    if (paramName.match(/\[(\d+)?\]$/)) {

                        // create key if it doesn't exist
                        const key = paramName.replace(/\[(\d+)?\]/, '');
                        if (!obj[key]) obj[key] = [];

                        // if it's an indexed array e.g. colors[2]
                        if (paramName.match(/\[\d+\]$/)) {
                            // get the index value and add the entry at the appropriate position
                            const index = /\[(\d+)\]/.exec(paramName)[1];
                            obj[key][index] = paramValue;
                        } else {
                            // otherwise add the value to the end of the array
                            obj[key].push(paramValue);
                        }
                    } else if (!obj[paramName]) {
                        // if it doesn't exist, create property
                        obj[paramName] = paramValue;
                    } else if (obj[paramName] && typeof obj[paramName] === 'string') {
                        // if property does exist and it's a string, convert it to an array
                        obj[paramName] = [obj[paramName]];
                        obj[paramName].push(paramValue);
                    } else {
                        // otherwise add the property
                        obj[paramName].push(paramValue);
                    }

                }
            }
            return obj;
        },
        getMyName (email = false, user = null) {
            let name = "";
            let nameUser = this.$user;
            if (user != null) {
                nameUser = user;
            }
            if (nameUser) {
                if (nameUser.name) name = nameUser.name;
                if (nameUser.surname) {
                    if (name.length > 0) name += " ";
                    name += nameUser.surname;
                }
                if (!nameUser.name) {
                    if (name.length > 0) {
                        name +=  + nameUser.cif;
                    } else {
                        name = nameUser.cif;
                    }
                }
                if (email && nameUser.email) {
                    if (name.length === 0) {
                        name = nameUser.email;
                    }
                }
            }
            return name.toUpperCase();
        },
        setPercentage (step) {
            ApiRepository.setInvoicePercentage(step, this.invoice._id)
                .then((res) => {
                    this.invoice = res.data.invoice;
                    this.percentage = this.invoice.invoiceProgress;
                });
        },
        makeAction (i) {
            if (i === 0) {
                if (this.chatInformation.invoice === null) {
                    this.$root.$emit('show-snackbar', {message: this.$t('chat.noInvoiceInChat'), color: 'error'});
                } else
                    this.seeInvoice();
            } else if (i === 1) {
                this.seeFiles();
            } else if (i === 2 && this.$refs.paymentInformationModal) {
                this.$refs.paymentInformationModal.openModal();
            } else if (i === 3) {
                console.log(this.$refs.generateContractByppayPdf);
                this.$refs.generateContractByppayPdf.openModal();
            } else if (i === 4 && this.archived === false) {
                this.archiveChat();
            } else if (i === 5 && this.archived === true) {
                this.unArchiveChat();
            } else if (i === 6) {
                this.addToCalendar();
            }
        },
        archiveChat () {
            ApiRepository.archiveChat(this.idChat).then(res => {
                this.$router.push({name: 'InvoiceChats'});
            });
        },
        unArchiveChat () {
            ApiRepository.unArchiveChat(this.idChat).then(res => {
                console.log(res);
                this.fetch();
            });
        }
    },
    sockets: {
        REFRESH_CHAT () {
            console.log("REFRESH_CHAT");
            this.readMessages = true;
            this.fetch();
        }
    }
};
</script>

<style scoped>
.v-app-bar{
}
.message-out {
    background: #407FFF;
    color: white;
    margin-left: 50%;
    margin-right: 5%;
    border-radius: 15px 0 15px 15px ;
}
.message-in {
    background: #F1F0F0;
    color: black;
    margin-left: 5%;
    margin-right: 50%;
    border-radius: 0 25px 25px ;
}
</style>
